import { render, staticRenderFns } from "./CustomerMain.vue?vue&type=template&id=639b25d8&scoped=true"
import script from "./CustomerMain.vue?vue&type=script&lang=js"
export * from "./CustomerMain.vue?vue&type=script&lang=js"
import style0 from "./CustomerMain.vue?vue&type=style&index=0&id=639b25d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b25d8",
  null
  
)

export default component.exports